import React, { useEffect, useState } from "react";
import {
  getFreeJobSpecificQuestionsApi,
  getJobSpecificQuestionsApi,
} from "../../../../api/candidate";
import Utils from "../../../../utils/Utils";
import WebUtils from "../../../../utils/WebUtils";
import { Input, Select, Skeleton } from "antd";
import Icon from "../../../../assets/Icon";
import JobSpecificCard from "./JobSpecificCard";
import { getJobSpecificFilterApiB2BCand } from "../../../../api/b2b-candidate";

const JobSpecificMain = ({
  specificFilterData,
  guideId,
  userDetail,
  industryId,
  setLoading,
  setModuleInfo,
  moduleInfo,
}) => {
  const [skillName, setSkillName] = useState(null);
  const [difficulty, setDifficulty] = useState(null);
  const [pageSize, setPageSize] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchText, setSearchText] = useState("");
  const [searchButtonText, setSearchButtonText] = useState("");
  const [skeletonLoading, setSkeletonLoading] = useState(false);
  const [jobSpecificQuestions, setJobSpecificQuestions] = useState(null);

  const onPageChange = (page, size) => {
    setCurrentPage(page);
    setPageSize(size);
    getSpecificGuideDataFunc(page - 1, size, searchButtonText);
  };

  const getSpecificGuideDataFunc = async (pageNo, pageSize, search) => {
    let url;
    if (industryId) {
      url = `${getJobSpecificFilterApiB2BCand}?jobGuideIdentifier=${guideId}&skillName=${
        skillName ? encodeURIComponent(skillName) : ""
      }&difficulty=${difficulty || ""}&searchValue=${
        search || ""
      }&pageNumber=${pageNo}&pageSize=${pageSize}`;
    } else {
      url = `${getJobSpecificFilterApiB2BCand}?jobGuideIdentifier=${guideId}&skillName=${
        skillName ? encodeURIComponent(skillName) : ""
      }&difficulty=${difficulty || ""}&searchValue=${
        search || ""
      }&pageNumber=${pageNo}&pageSize=${pageSize}`;
    }

    setSkeletonLoading(true);

    WebUtils.httpOperations(url, {}, "GET")
      .then((result) => {
        setSkeletonLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          setJobSpecificQuestions(result.data.data);
        } else {
          setJobSpecificQuestions(null);
        }
      })
      .catch((err) => {
        setSkeletonLoading(false);
        console.log(err);
      });
  };

  const handleSearch = () => {
    setSearchButtonText(searchText);
    setCurrentPage(1);
    getSpecificGuideDataFunc(0, pageSize, searchText);
  };
  const handleClearSearch = () => {
    setSearchText("");
    setSearchButtonText("");
    setCurrentPage(1);
    getSpecificGuideDataFunc(0, pageSize, "");
  };

  const handleSkillNameChange = (value) => {
    setSkillName(value);
  };
  const handleDifficultyChange = (value) => {
    setDifficulty(value);
  };

  useEffect(() => {
    // if (difficulty || skillName) {
    setCurrentPage(1);
    getSpecificGuideDataFunc(0, pageSize);
    // }
  }, [difficulty, skillName]);

  // useEffect(() => {
  //   setCurrentPage(1);
  //   getSpecificGuideDataFunc(0, pageSize);
  // }, []);
  return (
    <div className="preparation-container xl:w-[950px] lg:w-[800px] w-full">
      <div className="w-full flex justify-center flex-col lg:flex-row gap-4 ">
        <div className="flex-1 mt-[1rem] flex flex-wrap gap-x-20 gap-y-3 justify-center driver-all-guide-search">
          <div className="flex items-start gap-3 flex-wrap">
            {skeletonLoading ? (
              <span>
                <Skeleton.Button
                  active
                  block
                  style={{ height: 35, width: 120 }}
                />
              </span>
            ) : (
              <Select
                className=""
                value={skillName}
                placeholder="Skill name"
                suffixIcon=<svg
                  width="16"
                  height="13"
                  viewBox="0 0 20 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.8327 8.16667H14.8327C15.7661 8.16667 16.2328 8.16667 16.5893 8.34832C16.9029 8.50811 17.1579 8.76308 17.3177 9.07668C17.4993 9.4332 17.4993 9.89991 17.4993 10.8333V16.5M10.8327 16.5V4.16667C10.8327 3.23325 10.8327 2.76654 10.651 2.41002C10.4912 2.09641 10.2363 1.84144 9.92267 1.68166C9.56615 1.5 9.09944 1.5 8.16602 1.5H5.16602C4.23259 1.5 3.76588 1.5 3.40936 1.68166C3.09576 1.84144 2.84079 2.09641 2.681 2.41002C2.49935 2.76654 2.49935 3.23325 2.49935 4.16667V16.5M18.3327 16.5H1.66602M5.41602 4.83333H7.91602M5.41602 8.16667H7.91602M5.41602 11.5H7.91602"
                    stroke="#98A2B3"
                    stroke-width="1.6"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                style={{
                  width: 120,
                }}
                dropdownStyle={{ width: 280 }}
                allowClear
                onChange={handleSkillNameChange}
                options={
                  specificFilterData?.skills
                    ? specificFilterData.skills?.map((c) => ({
                        label: c,
                        value: c,
                      })) // ✅ antd requires label & value
                    : []
                }
              />
            )}
            {skeletonLoading ? (
              <span>
                <Skeleton.Button
                  active
                  block
                  style={{ height: 35, width: 120 }}
                />
              </span>
            ) : (
              <Select
                className=""
                placeholder="Difficulty"
                value={difficulty}
                suffixIcon=<svg
                  width="15"
                  height="15"
                  viewBox="0 0 18 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.40156 1.8778C8.59363 1.48869 8.68966 1.29413 8.82004 1.23197C8.93347 1.17789 9.06525 1.17789 9.17869 1.23197C9.30906 1.29413 9.4051 1.48869 9.59717 1.8778L11.4194 5.56944C11.4761 5.68432 11.5045 5.74176 11.5459 5.78635C11.5826 5.82584 11.6266 5.85783 11.6754 5.88056C11.7306 5.90623 11.794 5.91549 11.9208 5.93402L15.9968 6.5298C16.4261 6.59253 16.6407 6.6239 16.74 6.72874C16.8264 6.81995 16.8671 6.94529 16.8506 7.06985C16.8317 7.21302 16.6763 7.36436 16.3656 7.66702L13.4172 10.5387C13.3253 10.6282 13.2794 10.673 13.2497 10.7263C13.2235 10.7734 13.2066 10.8252 13.2001 10.8788C13.1928 10.9393 13.2036 11.0025 13.2253 11.129L13.921 15.1851C13.9944 15.6129 14.031 15.8269 13.9621 15.9538C13.9021 16.0642 13.7955 16.1417 13.6719 16.1646C13.5299 16.1909 13.3378 16.0899 12.9536 15.8879L9.30966 13.9716C9.19613 13.9119 9.13936 13.882 9.07955 13.8703C9.0266 13.8599 8.97213 13.8599 8.91918 13.8703C8.85937 13.882 8.8026 13.9119 8.68906 13.9716L5.04512 15.8879C4.66095 16.0899 4.46886 16.1909 4.32683 16.1646C4.20325 16.1417 4.09662 16.0642 4.03663 15.9538C3.96768 15.8269 4.00437 15.6129 4.07774 15.1851L4.77342 11.129C4.79511 11.0025 4.80595 10.9393 4.79862 10.8788C4.79212 10.8252 4.77528 10.7734 4.74902 10.7263C4.71937 10.673 4.67341 10.6282 4.5815 10.5387L1.63315 7.66702C1.3224 7.36436 1.16703 7.21302 1.14812 7.06985C1.13167 6.94529 1.17231 6.81995 1.25872 6.72874C1.35804 6.6239 1.57266 6.59253 2.00189 6.5298L6.07794 5.93402C6.2047 5.91549 6.26808 5.90623 6.32328 5.88056C6.37215 5.85783 6.41615 5.82584 6.45284 5.78635C6.49427 5.74176 6.52262 5.68432 6.57933 5.56944L8.40156 1.8778Z"
                    stroke="#98A2B3"
                    stroke-width="1.6"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                style={{
                  width: 110,
                }}
                allowClear
                onChange={handleDifficultyChange}
                options={
                  specificFilterData?.difficulties
                    ? specificFilterData.difficulties?.map((c) => ({
                        label: c,
                        value: c.toLowerCase(),
                      })) // ✅ antd requires label & value
                    : []
                }
              />
            )}
          </div>
          <div className="flex items-center justify-center gap-2 flex-wrap">
            {skeletonLoading ? (
              <span>
                <Skeleton.Button
                  active
                  block
                  style={{ height: 35, width: 350 }}
                />
              </span>
            ) : (
              <Input
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                className="w-[350px] px-2 py-[0.36rem] border border-[#D0D5DD] shadow-sm"
                prefix={<Icon type="search-icon" />}
                // size="large"
                placeholder="Search"
                onPressEnter={handleSearch}
              />
            )}
            {skeletonLoading ? (
              <span>
                <Skeleton.Button active block style={{ height: 35 }} />
              </span>
            ) : (
              <button
                className="btn-orange py-[0.35rem] px-[1rem] text-[.9rem]"
                onClick={handleSearch}
              >
                Search
              </button>
            )}
            {searchButtonText && !skeletonLoading && (
              <button
                className="btn-white py-[0.35rem] px-[1rem] text-[.9rem]"
                onClick={handleClearSearch}
              >
                Clear
              </button>
            )}
          </div>
        </div>
      </div>
      <div className="mt-6 w-full">
        {skeletonLoading ? (
          <>
            <Skeleton.Button
              active
              block
              style={{ height: 180, marginBottom: 12 }}
            />
            <Skeleton.Button
              active
              block
              style={{ height: 180, marginBottom: 12 }}
            />
          </>
        ) : (
          <JobSpecificCard
            jobSpecificQuestions={jobSpecificQuestions}
            setJobSpecificQuestions={setJobSpecificQuestions}
            pageSize={pageSize}
            currentPage={currentPage}
            onPageChange={onPageChange}
            userDetail={userDetail}
            guideId={guideId}
            industryId={industryId}
            setLoading={setLoading}
            setModuleInfo={setModuleInfo}
            moduleInfo={moduleInfo}
          />
        )}
      </div>
    </div>
  );
};

export default JobSpecificMain;
